import React from "react";
import { Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";
import { StudentDailyReportReportingItemDTO } from "../../../models/dtos/work-reports/StudentDailyReportReportingItemDTO";
import StudentDailyReports from "../../../services/work-report/StudentDailyReports";
import ConfirmResetReportModalState, {
  ConfirmResetReportModalProps,
} from "./ConfirmResetReportModal.models";
import html2canvas from "html2canvas";

export default class ConfirmResetReportModal extends React.PureComponent<
  ConfirmResetReportModalProps,
  ConfirmResetReportModalState
> {
  studentDailyReports: StudentDailyReports;
  courseListRef: React.RefObject<any>;

  constructor(props: any) {
    super(props);
    this.courseListRef = React.createRef();
    this.studentDailyReports = new StudentDailyReports();
    this.state = {
      studentDailyReport: {
        isLiked: false,
        courses: [],
        electronicUsageTime: { hour: 0, minute: 0 },
        sleepTime: { hour: 0, minute: 0 },
        wakeUpTime: { hour: 0, minute: 0 },
      },
    };
  }

  componentDidMount = () => {
    this.getData();
  };

  captureDiv = async () => {
    const el = this.courseListRef.current as HTMLElement | null;
    if (!el) return;

    if (document.fonts?.ready) {
      // @ts-ignore
      await document.fonts.ready;
    }

    const prev = {
      height: el.style.height,
      overflow: el.style.overflow,
      maxHeight: el.style.maxHeight,
      scrollTop: el.scrollTop,
    };

    el.scrollTop = 0;
    el.style.height = `${el.scrollHeight}px`;
    el.style.maxHeight = "none";
    el.style.overflow = "visible";

    await new Promise((r) => setTimeout(r, 50));

    const canvas = await html2canvas(el, {
      backgroundColor: "#fff",
      useCORS: true,
      allowTaint: false,
      scale: Math.min(2, window.devicePixelRatio || 1),
      logging: false,
    });

    el.style.height = prev.height;
    el.style.maxHeight = prev.maxHeight;
    el.style.overflow = prev.overflow;
    el.scrollTop = prev.scrollTop;

    const image = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = image;
    link.download = "daily-report.png";
    link.click();
  };

  getData = () => {
    let self = this;
    this.studentDailyReports.getInQueury().then(function (response) {
      if (response !== null) {
        self.setState({
          studentDailyReport: {
            ...response,
            sleepTime: response.sleepTimeDto,
            electronicUsageTime: response.electronicUsageTimeDto,
            wakeUpTime: response.wakeUpTimeDto,
          },
        });
      } else {
        self.props.closeModal();
      }
    });
  };

  render(): React.ReactNode {
    let { studentDailyReport } = this.state;
    let { showModal, closeModal } = this.props;

    return (
      <>
        <Modal show={showModal} onHide={closeModal} animation={true}>
          <Modal.Header>
            <Modal.Title>
              <label>اخطار</label>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body style={{ textAlign: "right" }} dir={"ltr"}>
            <div className="bd-modal">
              <label>
                شما از قبل گزارشکار با مشخصات زیر ثبت کرده اید ایا مجدد تمایل به
                ثبت گزارش کار دارید ؟
              </label>
            </div>
            <div
              ref={this.courseListRef}
              style={{
                padding: 8,
                height: 400,
                overflow: "auto",
              }}
            >
              {this.basicInformationView()}
              <hr />
              {this.courseListView(studentDailyReport.courses)}
            </div>
          </Modal.Body>

          <Modal.Footer dir="ltr">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
              }}
            >
              <button className="btn btn btn-success" onClick={this.captureDiv}>
                دانلود
              </button>
              <div>
                <NavLink to={"/RegisterReport"}>
                  <button className="btn btn btn-primary"> بله</button>
                </NavLink>
                <button
                  className="ml-2 btn btn btn-outline-danger"
                  onClick={closeModal}
                >
                  {" "}
                  انصراف
                </button>
              </div>
            </div>
          </Modal.Footer>
        </Modal>
      </>
    );
  }

  basicInformationView() {
    let { studentDailyReport } = this.state;

    return (
      <div>
        <div>
          <label>
            <b>ساعت بیداری : </b>
            {studentDailyReport?.sleepTime?.hour ?? 0}:
            {studentDailyReport?.sleepTime?.minute ?? 0}
          </label>
        </div>
        <div>
          <label>
            <b>ساعت خواب: </b>
            {studentDailyReport?.wakeUpTime?.hour ?? 0}:
            {studentDailyReport?.wakeUpTime?.minute ?? 0}
          </label>
        </div>
        <div>
          <label>
            <b>میزان استفاده از فضای مجازی: </b>
            {studentDailyReport?.electronicUsageTime?.hour ?? 0}:
            {studentDailyReport?.electronicUsageTime?.minute ?? 0}
          </label>
        </div>
      </div>
    );
  }

  courseListView(courses: StudentDailyReportReportingItemDTO[]) {
    let content;
    if (courses !== null && courses.length > 0)
      content = (
        <>
          {courses.map((course, key) => {
            return (
              <div key={key}>
                <div>
                  <div>
                    <label>
                      <b>
                        <i
                          className="mdi mdi-book-open-page-variant"
                          style={{ color: "#d5912a" }}
                        ></i>{" "}
                        نام درس :{" "}
                      </b>
                      {course.courseTitle}{" "}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>
                        <i
                          className="mdi mdi-head-lightbulb-outline"
                          style={{ color: "#008500" }}
                        ></i>{" "}
                        نتیجه مطالعه :
                      </b>{" "}
                      {course.studyTextResult}{" "}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>
                        <i
                          className="mdi mdi-clipboard-list-outline"
                          style={{ color: "#8a35bf" }}
                        ></i>{" "}
                        تعداد تست :
                      </b>{" "}
                      {course.testPassedCount !== null
                        ? course.testPassedCount
                        : "تست نزده بودید"}{" "}
                    </label>
                  </div>
                  <div>
                    <label>
                      <b>
                        <i
                          className="mdi mdi-clock-outline"
                          style={{ color: "#c50202" }}
                        ></i>{" "}
                        ساعت مطالعه :
                      </b>{" "}
                      {course.studyTime.hour ?? 0} ساعت و{" "}
                      {course.studyTime.minute ?? 0} دقیقه{" "}
                    </label>
                  </div>
                </div>
                {courses.indexOf(course) !==
                courses.indexOf(courses[courses.length - 1]) ? (
                  <>
                    <br />
                    <hr />
                  </>
                ) : (
                  <></>
                )}
              </div>
            );
          })}
        </>
      );
    else content = <></>;
    return <>{content}</>;
  }
}
